import * as React from 'react';

import {
    Bar,
    BarChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
    // @ts-expect-error
} from 'recharts';

import {colors} from 'shells/colors/colors';
import type {Item} from 'shells/table/item-count-table';

import {channelValues} from '../helpers';

import {CompetitorsBarChartTooltip} from '.';

type Props = {
    domains: Item[];
};

export function DomainsBarChart(props: Props) {
    const data = props.domains.map((domain) => {
        const segment = {
            domainName: domain.bucket,
        } as const;

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        domain.segments &&
            domain.segments.forEach((seg) => {
                // This covers us so the total of percentages for each domain doesn't get over 100%
                // and mess up our graph display
                // @ts-expect-error
                segment[seg.bucket] = seg.count.percent - 0.0000001;
            });

        return segment;
    });

    const toPercent = (percentage: number) => `${percentage * 100}%`;

    const renderTooltip = (tooltipProps: {
        active: boolean;
        payload: {
            payload: any[];
        };
    }) => {
        return <CompetitorsBarChartTooltip {...tooltipProps} />;
    };

    return (
        <ResponsiveContainer height={400} width='100%'>
            <BarChart
                width={1000}
                height={360}
                data={data}
                layout='vertical'
                margin={{
                    top: 40,
                    right: 60,
                    left: 100,
                    bottom: 20,
                }}
            >
                <Legend
                    verticalAlign='top'
                    align='right'
                    wrapperStyle={{top: '20px'}}
                    iconSize={10}
                    iconType='circle'
                />
                <CartesianGrid horizontal={false} />
                <XAxis type='number' tickFormatter={toPercent} />
                <YAxis dataKey='domainName' type='category' />
                <Tooltip
                    content={renderTooltip}
                    cursor={{fill: colors.offWhiteMd, strokeWidth: 1, cursor: 'pointer'}}
                />
                {channelValues.map((channel) => (
                    <Bar
                        className='pointer-cursor'
                        key={channel.name}
                        dataKey={channel.name}
                        stackId='a'
                        barSize={30}
                        fill={channel.fill}
                        layout='vertical'
                    />
                ))}
            </BarChart>
        </ResponsiveContainer>
    );
}
